var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('notifications'),_c('side-bar',{scopedSlots:_vm._u([{key:"links",fn:function(props){return [_c('sidebar-item',{attrs:{"link":{ name: 'Dashboard', path: '/manager/main', icon: 'ni layout-11 text-primary', }}}),_c('sidebar-item',{attrs:{"link":{
          name: 'Accounts',
          icon: 'ni add-27 text-green',
          path: '/manager/users'
        }}}),_c('sidebar-item',{attrs:{"link":{
          name: 'Courses',
          icon: 'ni certificate text-info',
          path: '/courses'
        }}}),_c('sidebar-item',{attrs:{"link":{
          name: 'Classes',
          icon: 'ni show-room text-default',
          path: '/classes'
        }}}),_c('sidebar-item',{attrs:{"link":{
          name: 'Homework',
          icon: 'ni homework',
          path: '/manager/homework'
        }}}),_c('sidebar-item',{attrs:{"link":{
          name: 'Schedule',
          icon: 'ni event-confirm text-red',
          path: '/manager/schedule'
        }}}),_c('sidebar-item',{attrs:{"link":{
          name: 'Resources',
          icon: 'ni filter-organization',
          path: '/manager/resources'
        }}}),_c('sidebar-item',{attrs:{"link":{
          name: 'Invoices',
          icon: 'ni money-bag text-green',
          path: '/manager/payments'
        }}})]}}])}),_c('div',{staticClass:"main-content"},[_c('dashboard-navbar',{attrs:{"type":_vm.$route.meta.navbarType}}),_c('div',{on:{"click":function($event){return _vm.$sidebar.displaySidebar(false)}}},[_c('fade-transition',{attrs:{"duration":200,"origin":"center top","mode":"out-in"}},[_c('router-view')],1)],1),(!_vm.$route.meta.hideFooter)?_c('content-footer'):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }